export const LOOKUP_TABLES_LOADING = "GLOBAL_LOOKUP_TABLES_LOADING";
export const LOOKUP_TABLES_LOADED = "GLOBAL_LOOKUP_TABLES_LOADED";
export const STORE_PROFILE = "GLOBAL_STORE_PROFILE";
export const ADD_INVITATIONS="GLOBAL_ADD_INVITATIONS";
export const STORE_TENANTS = "GLOBAL_STORE_TENANTS";
export const RESET_TENANTS = "GLOBAL_RESET_TENANTS";

// prefix contstant values to avoid name conflict between action types